import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../services/supabase';
import { FaSignOutAlt, FaUserShield, FaBell } from 'react-icons/fa';

function SecurityAlertsBell() {
  const { getAdminToken } = useAuth();
  const [alerts, setAlerts] = useState({ fraud_alerts: [], lockout_alerts: [], total: 0 });
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  const fetchAlerts = async () => {
    try {
      const token = getAdminToken();
      if (!token) return;
      const { data, error } = await supabase.rpc('admin_get_security_alerts', { p_admin_token: token });
      if (!error && data && !data.error) setAlerts(data);
    } catch (_) {}
  };

  useEffect(() => {
    fetchAlerts();
    const id = setInterval(fetchAlerts, 60000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const total = alerts.total || 0;

  return (
    <div ref={boxRef} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          position: 'relative', background: 'none', border: 'none', cursor: 'pointer',
          padding: 8, display: 'flex', alignItems: 'center',
        }}
        title="Təhlükəsizlik xəbərdarlıqları"
      >
        <FaBell size={18} color={total > 0 ? '#E63950' : '#888'} />
        {total > 0 && (
          <span style={{
            position: 'absolute', top: 0, right: 0, background: '#E63950', color: '#fff',
            borderRadius: '50%', fontSize: 11, fontWeight: 700,
            minWidth: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '0 3px',
          }}>{total}</span>
        )}
      </button>

      {open && (
        <div style={{
          position: 'absolute', right: 0, top: '110%', width: 320, maxHeight: 360, overflowY: 'auto',
          background: '#fff', border: '1px solid #eee', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          zIndex: 1000, padding: 12,
        }}>
          <strong style={{ fontSize: 13 }}>Təhlükəsizlik xəbərdarlıqları</strong>
          {total === 0 && (
            <p style={{ fontSize: 13, color: '#888', marginTop: 8 }}>Son 24 saatda heç bir xəbərdarlıq yoxdur ✅</p>
          )}
          {alerts.fraud_alerts?.map((f) => (
            <div key={f.id} style={{ padding: '8px 0', borderBottom: '1px solid #f3f3f3', fontSize: 13 }}>
              🚨 <strong>{f.severity}</strong> — {f.fraud_type}
              <div style={{ color: '#999', fontSize: 11 }}>{new Date(f.created_at).toLocaleString('az-AZ')}</div>
            </div>
          ))}
          {alerts.lockout_alerts?.map((l, i) => (
            <div key={i} style={{ padding: '8px 0', borderBottom: '1px solid #f3f3f3', fontSize: 13 }}>
              🔒 Admin login lockout — <strong>{l.email}</strong>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function Header() {
  const { admin, logout } = useAuth();

  return (
    <div className="sa-header">
      <h2 className="sa-header-title">🛡️ Super Admin</h2>

      <div className="sa-header-right">
        <SecurityAlertsBell />

        <div className="sa-admin-info">
          <FaUserShield size={18} color="#FF6B35" />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className="sa-admin-name">{admin?.full_name}</span>
            <span className="sa-admin-role">{admin?.role === 'accountant' ? 'Mühasib' : admin?.role}</span>
          </div>
        </div>

        <button onClick={logout} className="sa-logout-btn">
          <FaSignOutAlt size={16} />
          <span className="sa-logout-text">Çıxış</span>
        </button>
      </div>
    </div>
  );
}
